var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import ChatMessage from './ChatMessage.vue';
import FileUpload from './FileUpload.vue';
import WebSocketService from '../../api/WebSocketService';
import { CachePocily } from '../../common/Cache';
import { ECache } from '../../enum/ECache';
import CACHE_KEY from '../../constant/cacheKey';
import { WebSocketConfig } from '../../config/websocket';
import RobotService from '../../api/RobotService';
var AIAssistant = (function (_super) {
    __extends(AIAssistant, _super);
    function AIAssistant() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showDialog = false;
        _this.inputMessage = '';
        _this.selectedFile = null;
        _this.messages = [];
        _this.unreadCount = 0;
        _this.isTyping = false;
        _this.wsService = null;
        _this.previewImageVisible = false;
        _this.previewImageUrl = '';
        _this.editRobotName = false;
        _this.editRobotNameValue = '';
        _this.loadingHistory = false;
        _this.noMoreHistory = false;
        _this.historyStart = 0;
        _this.historyLimit = 10;
        _this.total = 0;
        _this.e_time = null;
        _this.aiInfoVisible = false;
        _this.aiInfo = {};
        _this.quickActions = [
            { text: 'AI助理能为您做什么？' },
            { text: '如何代客下单？' },
            { text: '如何获取商机？' },
        ];
        _this.showScrollToBottom = false;
        _this.handlePaste = function (event) { return __awaiter(_this, void 0, Promise, function () {
            var clipboardData, files, file, maxFileSize, error_1, items, i, item, blob, maxFileSize, file, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clipboardData = event.clipboardData;
                        if (!clipboardData)
                            return [2];
                        files = clipboardData.files;
                        if (!(files && files.length > 0)) return [3, 5];
                        event.preventDefault();
                        file = files[0];
                        maxFileSize = 10 * 1024 * 1024;
                        if (file.size > maxFileSize) {
                            this.$message.error("\u6587\u4EF6\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7 " + this.formatFileSize(maxFileSize));
                            return [2];
                        }
                        if (!this.isValidFileType(file)) {
                            this.$message.error('不支持的文件类型，请选择图片或Excel文件');
                            return [2];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        this.$message.info('正在处理粘贴的文件...');
                        return [4, this.processPastedFile(file)];
                    case 2:
                        _a.sent();
                        return [3, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error('粘贴文件处理失败:', error_1);
                        this.$message.error('文件处理失败，请重试');
                        return [3, 4];
                    case 4: return [2];
                    case 5:
                        items = clipboardData.items;
                        if (!items) return [3, 14];
                        i = 0;
                        _a.label = 6;
                    case 6:
                        if (!(i < items.length)) return [3, 14];
                        item = items[i];
                        if (!(item.type.indexOf('image') !== -1)) return [3, 13];
                        event.preventDefault();
                        blob = item.getAsFile();
                        if (!blob) return [3, 11];
                        maxFileSize = 10 * 1024 * 1024;
                        if (blob.size > maxFileSize) {
                            this.$message.error("\u56FE\u7247\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7 " + this.formatFileSize(maxFileSize));
                            return [2];
                        }
                        _a.label = 7;
                    case 7:
                        _a.trys.push([7, 9, , 10]);
                        this.$message.info('正在处理粘贴的图片...');
                        file = new File([blob], "\u7C98\u8D34\u7684\u56FE\u7247_" + Date.now() + "." + this.getImageExtensionFromType(item.type), {
                            type: item.type,
                            lastModified: Date.now()
                        });
                        return [4, this.processPastedFile(file)];
                    case 8:
                        _a.sent();
                        return [3, 10];
                    case 9:
                        error_2 = _a.sent();
                        console.error('粘贴图片处理失败:', error_2);
                        this.$message.error('图片处理失败，请重试');
                        return [3, 10];
                    case 10: return [3, 12];
                    case 11:
                        this.$message.error('无法获取图片数据，请重试');
                        _a.label = 12;
                    case 12: return [2];
                    case 13:
                        i++;
                        return [3, 6];
                    case 14: return [2];
                }
            });
        }); };
        _this.handleDrop = function (event) { return __awaiter(_this, void 0, Promise, function () {
            var files, file, maxFileSize, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        event.stopPropagation();
                        console.log("[" + Date.now() + "] handleDrop triggered");
                        files = event.dataTransfer ? event.dataTransfer.files : null;
                        if (!(files && files.length > 0)) return [3, 4];
                        file = files[0];
                        maxFileSize = 10 * 1024 * 1024;
                        if (file.size > maxFileSize) {
                            this.$message.error("\u6587\u4EF6\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7 " + this.formatFileSize(maxFileSize));
                            return [2];
                        }
                        if (!this.isValidFileType(file)) {
                            this.$message.error('不支持的文件类型，请选择图片或Excel文件');
                            return [2];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        this.$message.info('正在处理拖拽的文件...');
                        return [4, this.processPastedFile(file)];
                    case 2:
                        _a.sent();
                        return [3, 4];
                    case 3:
                        error_3 = _a.sent();
                        console.error('拖拽文件处理失败:', error_3);
                        this.$message.error('文件处理失败，请重试');
                        return [3, 4];
                    case 4: return [2];
                }
            });
        }); };
        return _this;
    }
    AIAssistant.prototype.mounted = function () {
        return __awaiter(this, void 0, Promise, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.initWebSocket();
                this.robotService = RobotService.getInstance();
                this.e_time = null;
                this.$nextTick(function () {
                    _this.scrollToBottom();
                });
                return [2];
            });
        });
    };
    AIAssistant.prototype.initWebSocket = function () {
        return __awaiter(this, void 0, Promise, function () {
            var cache, loginInfo, token, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        this.wsService = WebSocketService.getInstance();
                        cache = CachePocily.getInstance(ECache.LocCache);
                        loginInfo = cache.getData(CACHE_KEY.LOGIN);
                        token = loginInfo && loginInfo.userInfo ? JSON.parse(loginInfo.userInfo).token : null;
                        if (!token) return [3, 2];
                        return [4, this.wsService.connect(WebSocketConfig.AI_ASSISTANT_URL, token, this.robotCode)];
                    case 1:
                        _a.sent();
                        this.wsService.addMessageHandler(this.handleWebSocketMessage);
                        _a.label = 2;
                    case 2: return [3, 4];
                    case 3:
                        error_4 = _a.sent();
                        console.error('WebSocket连接失败:', error_4);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    AIAssistant.prototype.handleWebSocketMessage = function (message) {
        if (message.type === WebSocketConfig.MESSAGE_TYPES.AI_RESPONSE) {
            var now = Date.now();
            if (!this.e_time || !this.isToday(this.e_time)) {
                this.e_time = now;
            }
            this.addMessage({
                id: this.generateMessageId(),
                type: 'ai_response',
                contentType: message.data.message_type,
                content: message.data.content,
                timestamp: now
            });
            this.isTyping = false;
            if (!this.showDialog) {
                this.unreadCount++;
            }
        }
    };
    AIAssistant.prototype.toggleDialog = function () {
        var _this = this;
        this.showDialog = !this.showDialog;
        if (this.showDialog) {
            this.unreadCount = 0;
            this.$nextTick(function () {
                _this.scrollToBottom();
                _this.focusInput();
            });
        }
    };
    AIAssistant.prototype.sendQuickMessage = function (text) {
        this.inputMessage = text;
        this.sendMessage();
    };
    AIAssistant.prototype.sendMessage = function () {
        var _this = this;
        var message = this.inputMessage.trim();
        if (!message && !this.selectedFile)
            return;
        var now = Date.now();
        if (!this.e_time || !this.isToday(this.e_time)) {
            this.e_time = now;
        }
        if (this.selectedFile) {
            this.addMessage({
                id: this.generateMessageId(),
                type: 'user',
                contentType: this.selectedFile.contentType,
                content: this.selectedFile.content,
                fileName: this.selectedFile.name,
                fileSize: this.selectedFile.size,
                timestamp: now
            });
            this.sendToWebSocket({
                type: WebSocketConfig.MESSAGE_TYPES.USER_FILE,
                file: this.selectedFile
            });
        }
        if (message) {
            this.addMessage({
                id: this.generateMessageId(),
                type: 'user',
                contentType: 'text',
                content: message,
                timestamp: now
            });
            this.sendToWebSocket({
                type: WebSocketConfig.MESSAGE_TYPES.USER_MESSAGE,
                content: message
            });
        }
        this.inputMessage = '';
        this.selectedFile = null;
        this.isTyping = true;
        this.$nextTick(function () {
            _this.scrollToBottom();
        });
    };
    AIAssistant.prototype.addMessage = function (message) {
        var _this = this;
        this.messages.push(message);
        if (this.messages.length === 1) {
            this.e_time = message.timestamp;
        }
        this.$nextTick(function () {
            _this.scrollToBottom();
        });
    };
    AIAssistant.prototype.handleFileSelected = function (file) {
        this.selectedFile = file;
        this.sendMessage();
    };
    AIAssistant.prototype.handleKeydown = function (event) {
        if (event.key === 'Enter' && !event.shiftKey && !this.isTyping) {
            event.preventDefault();
            this.sendMessage();
        }
    };
    AIAssistant.prototype.clearMessages = function () {
        var _this = this;
        this.$confirm('确定要清空所有对话记录吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.messages = [];
                this.isTyping = false;
                try {
                    this.robotService.clearRobotMessage().then(function (res) {
                        if (res.data.success) {
                            _this.$message.success('清空成功');
                            _this.historyStart = 0;
                            _this.historyLimit = 10;
                            _this.total = 0;
                            _this.noMoreHistory = false;
                            _this.messages = [];
                            _this.e_time = null;
                        }
                        else {
                            _this.$message.error(res.data.msg);
                        }
                    }).catch(function (err) {
                        _this.$message.error('清空失败');
                    });
                }
                catch (e) {
                    this.$message.error('清空失败');
                }
                return [2];
            });
        }); }).catch(function () { });
    };
    AIAssistant.prototype.previewImage = function (imageUrl) {
        this.previewImageUrl = imageUrl;
        this.previewImageVisible = true;
    };
    AIAssistant.prototype.closePreviewImage = function () {
        this.previewImageVisible = false;
        this.previewImageUrl = '';
    };
    AIAssistant.prototype.downloadFile = function (message) {
        console.log('downloadFile', message);
        try {
            if (message.contentType !== 'file') {
                this.$message.error('该消息不是文件类型，无法下载');
                return;
            }
            if (!message.content || !message.fileName) {
                this.$message.error('文件信息不完整，无法下载');
                return;
            }
            var blob = void 0;
            var url = void 0;
            if (typeof message.content === 'string' || (typeof message.content === 'object' && message.content.thumb_media_id)) {
                if (typeof message.content === 'object') {
                    message.content = message.content.thumb_media_id;
                }
                if (message.content.startsWith('http://') || message.content.startsWith('https://')) {
                    var link_1 = document.createElement('a');
                    link_1.href = message.content;
                    link_1.download = message.fileName;
                    link_1.target = '_blank';
                    document.body.appendChild(link_1);
                    link_1.click();
                    document.body.removeChild(link_1);
                    return;
                }
                if (message.content.includes('base64,')) {
                    var base64Data = message.content.split('base64,')[1];
                    var byteCharacters = atob(base64Data);
                    var byteNumbers = new Array(byteCharacters.length);
                    for (var i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    var byteArray = new Uint8Array(byteNumbers);
                    var mimeType = 'application/octet-stream';
                    if (message.fileName.toLowerCase().endsWith('.xlsx')) {
                        mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                    }
                    else if (message.fileName.toLowerCase().endsWith('.xls')) {
                        mimeType = 'application/vnd.ms-excel';
                    }
                    else if (message.fileName.toLowerCase().endsWith('.pdf')) {
                        mimeType = 'application/pdf';
                    }
                    else if (message.fileName.toLowerCase().match(/\.(jpg|jpeg|png|gif|bmp)$/i)) {
                        mimeType = 'image/' + (message.fileName.split('.').pop() ? message.fileName.split('.').pop().toLowerCase() : '');
                    }
                    blob = new Blob([byteArray], { type: mimeType });
                }
                else {
                    blob = new Blob([message.content], { type: 'text/plain;charset=utf-8' });
                }
            }
            else {
                this.$message.error('不支持的文件格式');
                return;
            }
            url = window.URL.createObjectURL(blob);
            var link = document.createElement('a');
            link.href = url;
            link.download = message.fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            this.$message.success("\u6587\u4EF6\"" + message.fileName + "\"\u4E0B\u8F7D\u6210\u529F");
        }
        catch (error) {
            console.error('文件下载失败:', error);
            this.$message.error('文件下载失败，请重试');
        }
    };
    AIAssistant.prototype.scrollToBottom = function () {
        var container = this.$refs.messagesContainer;
        if (container) {
            container.scrollTop = container.scrollHeight;
        }
    };
    AIAssistant.prototype.focusInput = function () {
        var input = this.$refs.messageInput;
        if (input) {
            input.focus();
        }
    };
    AIAssistant.prototype.generateMessageId = function () {
        return Date.now().toString() + Math.random().toString(36).substr(2, 9);
    };
    AIAssistant.prototype.onDialogToggle = function (show) {
        var _this = this;
        if (show) {
            document.body.style.overflow = 'hidden';
            this.$nextTick(function () {
                _this.addPasteListener();
            });
        }
        else {
            document.body.style.overflow = '';
            this.removePasteListener();
        }
    };
    AIAssistant.prototype.beforeDestroy = function () {
        if (this.wsService) {
            this.wsService.removeMessageHandler(this.handleWebSocketMessage);
            this.wsService.disconnect();
        }
        this.removePasteListener();
        document.body.style.overflow = '';
    };
    AIAssistant.prototype.onMenuClick = function (item) {
        this.sendToWebSocket({
            type: WebSocketConfig.MESSAGE_TYPES.USER_MENU_CLICK,
            content: item
        });
    };
    AIAssistant.prototype.sendToWebSocket = function (data) {
        if (this.wsService) {
            this.wsService.sendMessage(data);
        }
    };
    AIAssistant.prototype.onEditRobotNameChange = function (val) {
        var _this = this;
        if (val) {
            this.editRobotNameValue = this.robotName;
            this.$nextTick(function () {
                _this.$refs.robotNameInput && _this.$refs.robotNameInput.focus();
            });
        }
    };
    AIAssistant.prototype.handleRobotNameSave = function () {
        return __awaiter(this, void 0, void 0, function () {
            var oldName, newName, params;
            var _this = this;
            return __generator(this, function (_a) {
                oldName = this.robotName;
                newName = this.editRobotNameValue.trim();
                if (!newName || newName === this.robotName) {
                    this.editRobotName = false;
                    return [2];
                }
                try {
                    this.$emit('update:robotName', newName);
                    this.robotName = newName;
                    params = {
                        robot_name: newName
                    };
                    this.robotService.updateRobotName(params).then(function (res) {
                        if (res.data.success) {
                            _this.$message.success('AI助手名称更新成功');
                        }
                        else {
                            _this.$message.error(res.data.msg);
                            _this.$emit('update:robotName', oldName);
                            _this.robotName = oldName;
                        }
                    }).catch(function (err) {
                        _this.$message.error('AI助手名称更新失败');
                        _this.$emit('update:robotName', oldName);
                        _this.robotName = oldName;
                    });
                }
                catch (e) {
                    this.$message.error('AI助手名称更新失败');
                    this.$emit('update:robotName', oldName);
                    this.robotName = oldName;
                }
                this.editRobotName = false;
                return [2];
            });
        });
    };
    AIAssistant.prototype.loadHistoryMessages = function () {
        var _this = this;
        if (this.loadingHistory || this.noMoreHistory)
            return;
        this.loadingHistory = true;
        var container = this.$refs.messagesContainer;
        var savedScrollInfo = {};
        if (container && this.messages.length > 0) {
            savedScrollInfo = {
                firstVisibleMessageId: this.messages[0] ? this.messages[0].id : undefined,
                scrollTop: container.scrollTop,
                scrollHeight: container.scrollHeight
            };
        }
        try {
            var e_time = this.e_time ?
                new Date(this.e_time).toLocaleString('zh-CN', {
                    timeZone: 'Asia/Shanghai',
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                    hour12: false
                })
                    .replace(/\//g, '-')
                    .replace(/(\d+)-(\d+)-(\d+)/, function (match, p1, p2, p3) { return p1 + "-" + p2.padStart(2, '0') + "-" + p3.padStart(2, '0'); }) :
                null;
            var params = { limit: this.historyLimit, start: this.historyStart, e_time: e_time };
            this.robotService.getRobotMessageList(params).then(function (res) {
                if (res.data.success && Array.isArray(res.data.data)) {
                    _this.total = res.data.total || 0;
                    var historyMsgs_1 = res.data.data.map(function (item) {
                        var type = item.from === 'user' ? 'user' : 'ai_response';
                        var contentType = 'text';
                        var content = item.message_attribute.content;
                        var fileName = undefined;
                        var fileSize = undefined;
                        var timestamp = item.c_time ? new Date(item.c_time).getTime() : Date.now();
                        if (item.message_type === 1 && item.message_attribute.message_type === 'user_message') {
                            contentType = 'text';
                        }
                        else if (item.message_type === 2 && item.message_attribute.message_type === 'image') {
                            contentType = 'image';
                        }
                        else if (item.message_type === 3 && item.message_attribute.message_type === 'file') {
                            contentType = 'file';
                            fileName = item.message_attribute.file.name;
                            fileSize = item.message_attribute.file.size;
                        }
                        else if (item.message_type === 7 && item.message_attribute.message_type === 'link') {
                            contentType = 'link';
                        }
                        else if (item.message_type === 9 && item.message_attribute.message_type === 'menu') {
                            contentType = 'menu';
                        }
                        else if (item.message_type === 10 && item.message_attribute.message_type === 'select') {
                            contentType = 'select';
                        }
                        return {
                            id: String(item.id),
                            type: type,
                            contentType: contentType,
                            content: content,
                            fileName: fileName,
                            fileSize: fileSize,
                            timestamp: timestamp
                        };
                    });
                    historyMsgs_1 = historyMsgs_1.reverse();
                    _this.messages = historyMsgs_1.concat(_this.messages);
                    _this.historyStart += historyMsgs_1.length;
                    if (_this.messages.length >= _this.total) {
                        _this.noMoreHistory = true;
                    }
                    _this.$nextTick(function () {
                        if (_this.messages.length === historyMsgs_1.length) {
                            _this.scrollToBottom();
                        }
                        else {
                            _this.restoreScrollPosition(savedScrollInfo, historyMsgs_1.length);
                        }
                    });
                }
                else {
                    _this.noMoreHistory = true;
                }
            }).catch(function (err) {
                _this.$message.error('历史消息加载失败');
            });
        }
        catch (e) {
            this.$message.error('历史消息加载失败');
        }
        finally {
            this.loadingHistory = false;
        }
    };
    AIAssistant.prototype.restoreScrollPosition = function (savedScrollInfo, newMessagesCount) {
        var container = this.$refs.messagesContainer;
        if (!container || !savedScrollInfo.firstVisibleMessageId) {
            return;
        }
        var targetMessageElement = container.querySelector("[data-message-id=\"" + savedScrollInfo.firstVisibleMessageId + "\"]");
        if (targetMessageElement) {
            targetMessageElement.scrollIntoView({ block: 'start', behavior: 'auto' });
        }
        else {
            var newScrollHeight = container.scrollHeight;
            var heightDifference = newScrollHeight - (savedScrollInfo.scrollHeight || 0);
            var newScrollTop = (savedScrollInfo.scrollTop || 0) + heightDifference;
            container.scrollTop = Math.max(0, newScrollTop);
        }
    };
    AIAssistant.prototype.handleScroll = function () {
        var container = this.$refs.messagesContainer;
        if (!container)
            return;
        if (container.scrollTop === 0 && !this.loadingHistory && !this.noMoreHistory) {
            this.loadHistoryMessages();
        }
        this.showScrollToBottom = container.scrollTop < container.scrollHeight - container.clientHeight - 100;
    };
    AIAssistant.prototype.scrollToBottomIconClick = function () {
        this.scrollToBottom();
    };
    AIAssistant.prototype.isToday = function (ts) {
        var d = new Date(ts);
        var now = new Date();
        return d.getFullYear() === now.getFullYear() && d.getMonth() === now.getMonth() && d.getDate() === now.getDate();
    };
    AIAssistant.prototype.onSelectClick = function (item) {
        this.sendToWebSocket({
            type: WebSocketConfig.MESSAGE_TYPES.USER_SELECT_CLICK,
            content: item
        });
    };
    AIAssistant.prototype.addPasteListener = function () {
        var dialogElement = this.$el.querySelector('.ai-assistant-dialog');
        if (dialogElement) {
            dialogElement.addEventListener('paste', this.handlePaste);
        }
    };
    AIAssistant.prototype.removePasteListener = function () {
        var dialogElement = this.$el.querySelector('.ai-assistant-dialog');
        if (dialogElement) {
            dialogElement.removeEventListener('paste', this.handlePaste);
        }
    };
    AIAssistant.prototype.processPastedFile = function (file) {
        return __awaiter(this, void 0, Promise, function () {
            var fileData, fileUrl, fileUrl, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        fileData = {
                            name: file.name || "\u7C98\u8D34\u7684" + (this.isImageFile(file) ? '图片' : '文件') + "_" + Date.now() + this.getFileExtension(file),
                            size: file.size,
                            type: file.type,
                            lastModified: file.lastModified || Date.now()
                        };
                        if (!this.isImageFile(file)) return [3, 2];
                        return [4, this.uploadFileToServer(file)];
                    case 1:
                        fileUrl = _a.sent();
                        this.selectedFile = __assign({}, fileData, { contentType: 'image', content: fileUrl });
                        this.$message.success('图片粘贴成功，点击发送按钮或按Enter发送');
                        return [3, 4];
                    case 2: return [4, this.uploadFileToServer(file)];
                    case 3:
                        fileUrl = _a.sent();
                        this.selectedFile = __assign({}, fileData, { contentType: 'file', content: fileUrl });
                        this.$message.success('文件粘贴成功，点击发送按钮或按Enter发送');
                        _a.label = 4;
                    case 4: return [3, 6];
                    case 5:
                        error_5 = _a.sent();
                        throw error_5;
                    case 6: return [2];
                }
            });
        });
    };
    AIAssistant.prototype.isValidFileType = function (file) {
        var validImageTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
        var validExcelTypes = [
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ];
        var isValidImage = validImageTypes.includes(file.type) || file.type.startsWith('image/');
        var isValidExcel = validExcelTypes.includes(file.type) ||
            file.name.toLowerCase().endsWith('.xlsx') ||
            file.name.toLowerCase().endsWith('.xls');
        var isValid = isValidImage || isValidExcel;
        return isValid;
    };
    AIAssistant.prototype.isImageFile = function (file) {
        return file.type.startsWith('image/');
    };
    AIAssistant.prototype.getFileExtension = function (file) {
        if (file.name && file.name.includes('.')) {
            return '.' + file.name.split('.').pop();
        }
        var mimeToExt = {
            'image/jpeg': '.jpg',
            'image/png': '.png',
            'image/gif': '.gif',
            'application/vnd.ms-excel': '.xls',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xlsx'
        };
        return mimeToExt[file.type] || '';
    };
    AIAssistant.prototype.getFileIcon = function (file) {
        if (file.contentType === 'image') {
            return 'el-icon-picture';
        }
        else if (file.contentType === 'file') {
            return 'el-icon-document';
        }
        return 'el-icon-document';
    };
    AIAssistant.prototype.uploadFileToServer = function (file) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2, new Promise(function (resolve, reject) {
                        var formData = new FormData();
                        formData.append('file', file);
                        var xhr = new XMLHttpRequest();
                        xhr.upload.onprogress = function (event) {
                            if (event.lengthComputable) {
                                var percentComplete = (event.loaded / event.total) * 100;
                                console.log("\u4E0A\u4F20\u8FDB\u5EA6: " + percentComplete.toFixed(2) + "%");
                            }
                        };
                        xhr.onload = function () {
                            if (xhr.status === 200) {
                                try {
                                    var response = JSON.parse(xhr.responseText);
                                    if (response.success && response.data && response.data.full_path) {
                                        resolve(response.data.full_path);
                                    }
                                    else {
                                        reject(new Error(response.msg || '上传失败'));
                                    }
                                }
                                catch (e) {
                                    reject(new Error('响应格式错误'));
                                }
                            }
                            else {
                                reject(new Error("\u4E0A\u4F20\u5931\u8D25: HTTP " + xhr.status));
                            }
                        };
                        xhr.onerror = function () {
                            reject(new Error('网络错误'));
                        };
                        xhr.open('POST', '/supplierapi/upload');
                        xhr.send(formData);
                    })];
            });
        });
    };
    AIAssistant.prototype.formatFileSize = function (bytes) {
        var sizes = ['B', 'KB', 'MB', 'GB'];
        var i = Math.floor(Math.log(bytes) / Math.log(1024));
        return Math.round(bytes / Math.pow(1024, i) * 100) / 100 + ' ' + sizes[i];
    };
    AIAssistant.prototype.clearSelectedFile = function () {
        this.selectedFile = null;
        this.$message.info('已移除文件');
    };
    Object.defineProperty(AIAssistant.prototype, "inputPlaceholder", {
        get: function () {
            if (this.selectedFile) {
                return '已选择文件，可继续输入文字描述';
            }
            return '请输入消息，支持粘贴图片/文件(Ctrl+V)或拖拽文件，Shift+Enter换行';
        },
        enumerable: true,
        configurable: true
    });
    AIAssistant.prototype.handleDragOver = function (event) {
        event.preventDefault();
        event.stopPropagation();
    };
    AIAssistant.prototype.handleDragLeave = function (event) {
        event.preventDefault();
        event.stopPropagation();
    };
    AIAssistant.prototype.handleDragEnd = function (event) {
        event.preventDefault();
        event.stopPropagation();
    };
    AIAssistant.prototype.getImageExtensionFromType = function (mimeType) {
        if (mimeType.includes('jpeg') || mimeType.includes('jpg'))
            return 'jpg';
        if (mimeType.includes('png'))
            return 'png';
        if (mimeType.includes('gif'))
            return 'gif';
        if (mimeType.includes('webp'))
            return 'webp';
        return 'jpg';
    };
    AIAssistant.prototype.previewSelectedFile = function () {
        if (this.selectedFile && this.selectedFile.contentType === 'image') {
            this.previewImage(this.selectedFile.content);
        }
    };
    AIAssistant.prototype.showAIInfo = function () {
        var _this = this;
        this.robotService.getRobotInfo().then(function (res) {
            if (res.data.success) {
                _this.aiInfo = res.data.data;
                _this.aiInfoVisible = true;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }).catch(function (err) {
            _this.$message.error('获取AI助手信息失败');
        });
    };
    AIAssistant.prototype.closeAIInfo = function () {
        this.aiInfoVisible = false;
        this.aiInfo = {};
    };
    __decorate([
        Prop({ type: String, default: 'AI助理' })
    ], AIAssistant.prototype, "robotName", void 0);
    __decorate([
        Prop({ type: String, default: '' })
    ], AIAssistant.prototype, "robotCode", void 0);
    __decorate([
        Watch('showDialog')
    ], AIAssistant.prototype, "onDialogToggle", null);
    __decorate([
        Watch('editRobotName')
    ], AIAssistant.prototype, "onEditRobotNameChange", null);
    AIAssistant = __decorate([
        Component({
            components: {
                ChatMessage: ChatMessage,
                FileUpload: FileUpload
            }
        })
    ], AIAssistant);
    return AIAssistant;
}(Vue));
export default AIAssistant;
